module.exports = __webpack_public_path__ + "img/coding-test-active-tab.e345466d.svg";